var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVector106(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 295,
    height: 207,
    viewBox: "0 0 295 207",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.9398 0.259766C19.8198 31.5598 13.7198 67.4198 8.57984 106.86C8.20984 109.68 7.00984 123.06 6.82984 125.89L1.58984 205.21C18.7498 180.5 22.5898 176.5 40.8698 160.31C45.3498 156.34 54.1498 149.97 65.1398 143.7C68.4298 141.82 71.6998 140.09 74.9298 138.5C98.0698 127.09 124.68 123.78 151.23 124.1C218.96 124.92 277.05 84.0498 290.73 27.5898C292.93 18.4998 293.91 9.34977 293.81 0.269766",
    stroke: "#A8AEBE",
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector106);
export default __webpack_public_path__ + "static/media/vector10-6.27237906fcb27dbd217249fe91a0e11a.svg";
export { ForwardRef as ReactComponent };